import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import { authHeader } from "../../_helpers";
import { useTranslation } from "react-i18next";

const { webApiUrl } = window.appConfig;

const SendReminderDialog = ({
  open,
  onClose,
  selectedResolverIds,
  canSendReminderSelectedWorkOrders,
  onSendReminder,
  emails,
  status
}) => {
  const { t } = useTranslation();
  const [ccEmailList, setCcEmailList] = useState([]);
  const [ccEmailValid, setCcEmailValid] = useState(true);
  const [sendingReminder, setSendingReminder] = useState(false);

  
  const updateCCEmails = (value) => {
    const list = value.trim() !== "" ? value.replace(/\s/g, "").split(",") : [];
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = list.every((email) => email !== "" && regex.test(email));
    setCcEmailList(list);
    setCcEmailValid(isValid);
  };

  const SendReminderToResolvers = async () => {
    if (
      selectedResolverIds &&
      selectedResolverIds?.length > 0 &&
      ccEmailValid &&
      canSendReminderSelectedWorkOrders
    ) {
      setSendingReminder(true);

      try {
        const response = await fetch(`${webApiUrl}api/RepairRequest/SendReminder/`, {
          method: "POST",
          headers: authHeader("application/json"),
          body: JSON.stringify({
            resolverIdList: selectedResolverIds,
            ccEmails: ccEmailList,
          }),
        });

        const result = await response.json();

        if (result) {
         setSendingReminder(false)
         setCcEmailList([])
         setCcEmailValid(true)
         onClose(); 
         onSendReminder(true); 
        } else {
          alert(t("general.api.error"));
          setSendingReminder(false)
        }
      } catch (err) {
        console.error(err);
        alert(t("general.api.error"));
      } finally {
        setSendingReminder(false);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{status <= 0 ? t("workOrders.task.sendWorkOrder") : t("workOrders.task.sendReminder")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          disabled
          rows={2}
          variant="outlined"
          value={emails}
          margin="dense"
          id="resolverEmail"
          label={t("general.email.to")}
          type="email"
          fullWidth
        />
        <TextField
          autoFocus
          disabled={sendingReminder}
          error={!ccEmailValid}
          rows={2}
          variant="outlined"
          onChange={(e) => updateCCEmails(e.target.value)}
          margin="dense"
          id="ccemail"
          label="CC"
          type="email"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          disabled={sendingReminder}
          onClick={onClose}
          color="primary"
        >
          {t("general.cancel")}
        </Button>
        <Button
          disabled={!ccEmailValid || sendingReminder}
          onClick={SendReminderToResolvers}
          color="primary"
        >
         {status <= 0 ? t("workOrders.task.sendWorkOrder") : t("workOrders.task.sendReminder")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendReminderDialog;
